import styled from "styled-components";

const BaseParagraph = styled.p`
  margin: 0;
  font-family: Inter;
  line-height: 1.5rem;
`;

export const ContainerProductPriceOverviewPix = styled.div`
  display: flex;
  flex-direction: column;

  border-bottom: 0.063rem solid
    ${({ theme }) => theme.checkoutStepsOffers?.widgetBackground};

  gap: 0.5rem;

  padding: 1rem 0 0 0;

  width: 100%;
`;

export const Paragraph = styled(BaseParagraph)`
  font-size: 0.875rem;
  font-weight: 500;

  color: ${({ theme }) => theme?.groups?.secondaryText}!important;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;
`;

export const Discount = styled(Paragraph)`
  color: ${({ theme }) => theme.checkoutStepsOffers?.green} !important;
`;

export const ContentSpecialOffers = styled.section`
  padding: 0 0 1rem 0;

  border-bottom: 0.063rem solid
    ${({ theme }) => theme.checkoutStepsOffers?.widgetBackground};

  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const ContentTotalPrice = styled.div`
  padding: 0.5rem 0 1rem 0;
`;

export const ParagraphTotal = styled(BaseParagraph)`
  font-size: 1rem;
  font-weight: 500;

  color: ${({ theme }) => theme?.groups?.primaryText}!important;
`;

export const ParagraphTotalValue = styled(BaseParagraph)`
  font-size: 1rem;
  font-weight: 600;

  color: ${({ theme }) => theme?.groups?.primaryText}!important;
`;
